//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';
import TabelaGenerica from '../../../../../shared-components/generico/TabelaGenerica';
import mdAutocomplete from '../../../../../shared-components/autocomplete/mdAutocomplete';
import { getMoney } from '../../../../../common/functions/helpers';
import { prepareResponseData } from '../../../../../common/functions/http';
import StatusPassos from '../../../../../shared-components/workflow/StatusPassos';
import workspaceMixin from '../../../../../common/functions/workspace-filtros';


export default {
  name: 'AcordoTabelaDash',
  extends: TabelaGenerica,
  mixins: [workspaceMixin],
  props: {
    contrato: Object,
    tiposNegociacoes: {
      type: Array,
      required: true,
    },
    unidadeNegocio: {
      type: Number,
      default: null,
    },
    periodoNegociacao: {
      type: Number,
      default: null,
    },
    carregando: Boolean,
    bloquearConsulta: Boolean,
    paginas: Number,
  },
  data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      workflowAcordo: this.$api.workflowAcordo(this.$resource),
      entidade: 'DASH_ACORDO',
      canPost: false,
      somenteLeitura: false,
      nomContato: '',
      hasFilter: false,
      itemSelecionado: null,
      indexPagina: 0,
      justificativa: '',
      objetosSelecionados: [],
      podeAprovar: false,
      esperarRequest: false,
      justificativaGrid: 'Sem justificativa.',
      filtro: {
        tipoAcordo: '',
        status: 'AGUARDANDO_APROVACAO',
        tipoLinhaOrcamento: '',
        marca: '',
        linhaProduto: '',
        familia: '',
        produto: '',
        cliente: '',
        meuPassoPendente: true,
        meuPassoAprovado: false,
      },
      filtroCopy: {},
      statusNegociacoes: [
        { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') },
        { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) },
        { status: 'EM_ANALISE', descricao: this.$tc('status_entidade.em_analise', 1) },
        { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) },
      ],
      statusBloqueado: true,
      statusPassos: {},
    };
  },
  computed: {
    hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    },
  },
  components: {
    mdAutocomplete,
    StatusPassos,
    Paginate,
  },
  watch: {
    periodoNegociacao() {
      this.preencherFiltrosGerais();
    },
    unidadeNegocio() {
      this.preencherFiltrosGerais();
    },
  },
  methods: {
    prepareResponseData,
    getMoney,
    clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_ACORDO_TABELA_PAGINA', this.filtro, pagina);
    },
    refazPaginacao() {
      this.indexPagina = 0;
    },
    requestAbrirAcompanhamento(row) {
      const idAcordo = row.id;
      this.workflowAcordo.statusPasso({ idAcordo }, { idAcordo })
        .then((res) => {
          this.statusPassos = res.data;
          this.$refs.modalAcompanhamento.open();
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    verItem(row) {
      if (row) {
        let rota = null;
        switch (row.codTipoAcordo) {
          case 'FIXO':
            rota = 'verDetalhesNegociacaoFixoFluxo';
            break;
          case 'TABLOIDE':
            rota = 'verDetalhesNegociacaoTabloideFluxo';
            break;
          case 'NEGOCIACAO_PRECO':
            rota = 'verDetalhesNegociacaoPrecoFluxo';
            break;
          case 'POSITIVACAO':
            rota = 'verDetalhesPositivacaoFluxo';
            break;
          case 'CRESCIMENTO':
            rota = 'verDetalhesCrescimentoFluxo';
            break;
          default:
            return;
        }
        this.$router.push({ name: rota, params: { id: row.id } });
      }
    },
    toggleSelecaoGeral(selecao) {
      this.filteredList.forEach((item) => {
        item.selecionado = selecao;
      });
      this.objetosSelecionados = !selecao ? [] : ([...this.filteredList]);

      this.requestPermiteAprovar();
      this.$forceUpdate();
    },
    toggleSelecaoUnica(row) {
      setTimeout(() => {
        const selecao = row.selecionado;
        if (selecao) {
          this.objetosSelecionados.push(row);
          this.requestPermiteAprovar();
          return;
        }

        let indexO = null;
        this.objetosSelecionados.forEach((obj, index) => {
          if (obj.idWorkflow === row.idWorkflow) {
            indexO = index;
          }
        });
        this.objetosSelecionados.splice(indexO, 1);
        this.requestPermiteAprovar();
      });
    },
    requestPermiteAprovar() {
      this.podeAprovar = false;
      const lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeAprovar = false;
        return;
      }
      if (lista) {
        this.podeAprovar = true;
        lista.forEach((el) => {
          if (!this.ehAprovador(el)) {
            this.podeAprovar = false;
          }
        });
      }
    },
    limparSelecao() {
      this.podeAprovar = false;
      this.objetosSelecionados = [];
    },
    clickOnRow(row = null, index) {
      this.$emit('ACORDOTABELA_CLICK_LINHA', this.contrato, row, index);
    },
    ehAprovador(row) {
      return row.status === 'AGUARDANDO_APROVACAO' && row.aprovador === true;
    },
    temJustificativa(row) {
      return row.justificativa && row.justificativa !== '';
    },
    defaultClose() {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa() {
      this.$refs.inputJustificativaAnalise.hasValue = false;
      this.$refs.inputJustificativaAnalise.inputLength = 0;
      this.$refs.inputJustificativaAprovar.hasValue = false;
      this.$refs.inputJustificativaAprovar.inputLength = 0;
      this.$refs.inputJustificativaReprovar.hasValue = false;
      this.$refs.inputJustificativaReprovar.inputLength = 0;
      this.$forceUpdate();
    },
    fetchProduto(value) {
      value = this.montarFiltroProduto(value);

      return this.produtoResources.listarAtivos(value);
    },
    requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAnalise.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.justificativa = '';
    },
    requestRefreshFilteredList() {
      this.requestBuscarNegociacoesFilter();
    },
    requestBuscarMotivoLog(row) {
      this.acordoResources.logAcordo({ codigo: row.id })
        .then((response) => {
          const motivo = (response.data && response.data.length) ?
            response.data[response.data.length - 1].justificativa : 'Acordo sem justificativa.';
          this.justificativaGrid = motivo.justificativa || motivo;
          this.$refs.modalComentario.open();
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    filtrarModal() {
      this.requestBuscarNegociacoesFilter();
    },
    requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = '';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.filtro.meuPassoPendente = true;
      this.filtro.meuPassoAprovado = false;
      this.justificativa = '';

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idFamilia) {
        delete this.filtro.idFamilia;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    montarFiltroProduto(value) {
      const filtros = value;

      if (this.filtro.idMarca) {
        filtros.id_marca = this.filtro.idMarca;
      }
      if (this.filtro.idLinhaProduto) {
        filtros.id_familia = this.filtro.idLinhaProduto;
      }
      if (this.filtro.idFamilia) {
        filtros.id_familia = this.filtro.idFamilia;
      }

      filtros.nome = value.nome;

      return filtros;
    },
    requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalEnviarNegociacaoAnalise(row = null) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAnalise.open();
      this.itemSelecionado = row;
    },
    requestModalAprovarPassoNegociacao(row = null) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional(row = null) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao(row = null) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestAprovarPassosFluxoAcordo() {
      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowAcordo.aprovar({ idAcordo: this.itemSelecionado.id },
          { observacao: this.justificativa })
          .then(this.tratarAprovarSucesso)
          .catch((err) => {
            this.esperarRequest = false;
            this.$error(this, err);
          });
      } else {
        this.objetosSelecionados.forEach((el, idx) => {
          this.workflowAcordo.aprovar({ idAcordo: el.id },
            { observacao: this.justificativa })
            .then(() => {
              if (idx === (this.objetosSelecionados.length - 1)) {
                this.esperarRequest = false;
                this.recarregarAposAcaoEmMassa();
                this.$toast.create(this.$t('message.acordo_aprovado'), 'snack', 3E3);
              }
            })
            .catch((err) => {
              this.esperarRequest = false;
              this.$error(this, err);
            });
        });
      }
    },
    requestEnviarNegociacaoParaAnalise() {
      if (this.itemSelecionado) {
        this.workflowAcordo.enviarAnalise({ idAcordo: this.itemSelecionado.id },
          { observacao: this.justificativa })
          .then(this.tratarAnaliseSucesso)
          .catch((err) => {
            this.$error(this, err);
          });
      } else {
        this.objetosSelecionados.forEach((el, idx) => {
          this.workflowAcordo.enviarAnalise({ idAcordo: el.id },
            { observacao: this.justificativa })
            .then(() => {
              if (idx === (this.objetosSelecionados.length - 1)) {
                this.recarregarAposAcaoEmMassa();
                this.$toast.create(this.$t('message.acordo_enviado_analise'), 'snack', 3E3);
              }
            })
            .catch((err) => {
              this.$error(this, err);
            });
        });
      }
    },
    requestReprovarPassosNegociacao() {
      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowAcordo.reprovar({ idAcordo: this.itemSelecionado.id },
          { observacao: this.justificativa })
          .then(this.tratarReprovarSucesso)
          .catch((err) => {
            this.esperarRequest = false;
            this.$error(this, err);
          });
      } else {
        this.objetosSelecionados.forEach((el, idx) => {
          this.workflowAcordo.reprovar({ idAcordo: el.id },
            { observacao: this.justificativa })
            .then(() => {
              if (idx === (this.objetosSelecionados.length - 1)) {
                this.esperarRequest = false;
                this.recarregarAposAcaoEmMassa();
                this.$toast.create(this.$t('message.acordo_reprovado'), 'snack', 3E3);
              }
            })
            .catch((err) => {
              this.esperarRequest = false;
              this.$error(this, err);
            });
        });
      }
    },
    recarregarAposAcaoEmMassa() {
      this.requestFecharModaisDefault();
      this.requestVoltarTelaInicial();
      this.requestRefreshFilteredList();
    },
    tratarAprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_aprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarReprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_reprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAnaliseSucesso() {
      this.$toast.create(this.$t('message.acordo_enviado_analise'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAlterarSucesso() {
      this.itemSelecionado = null;
      this.requestFecharModaisDefault();
      this.requestRefreshFilteredList();
    },
    requestBuscarNegociacoesFilter() {
      this.requestVoltarTelaInicial();
      this.preencherFiltrosGerais();
      this.buscar('ACORDOTABELA_FILTER');
    },
    preencherFiltrosGerais() {
      this.filtro.periodo = this.periodoNegociacao;
      this.filtro.unidadeNegocio = this.unidadeNegocio;
    },
    buscar(evento) {
      this.limparSelecao();
      this.salvarWorkspace(this.entidade, this.filtro);
      this.$emit(evento, this.filtro);
    },
    limparTipoInvestimentoOrcamento() {
      this.filtro.idTipoLinhaOrcamento = null;
    },
    setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.nome;
    },
    setMarca(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.marca = hit.nomExtensao;
      this.limparProdutoCompleto();
    },
    limparMarca() {
      this.filtro.idMarca = null;
      this.limparProdutoCompleto();
    },
    setFamilia(hit) {
      this.filtro.idFamilia = hit.id;
      this.filtro.familia = hit.nomExtensao;
      this.limparProdutoCompleto();
    },
    limparFamilia() {
      this.filtro.idFamilia = null;
      this.limparProdutoCompleto();
    },
    setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
      this.limparProdutoCompleto();
    },
    limparLinhaProduto() {
      this.filtro.idLinhaProduto = null;
      this.limparProdutoCompleto();
    },
    setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    limparProdutoCompleto() {
      this.filtro.produto = '';
      this.limparProduto();
    },
    limparProduto() {
      this.filtro.idProduto = null;
    },
    setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    limparCliente() {
      this.filtro.idCliente = null;
    },
    setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao,
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    verificarMeuPassoPendente() {
      this.filtro.meuPassoPendente = !this.filtro.meuPassoPendente;
      if (this.filtro.meuPassoPendente) {
        this.filtro.status = 'AGUARDANDO_APROVACAO';
        this.statusBloqueado = true;
        this.filtro.meuPassoAprovado = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    verificarMeuPassoAprovado() {
      this.filtro.meuPassoAprovado = !this.filtro.meuPassoAprovado;
      if (this.filtro.meuPassoAprovado) {
        this.statusBloqueado = true;
        this.filtro.meuPassoPendente = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    preencherFiltros(filtros) {
      this.filtro.tipoAcordo = filtros.tipoAcordo || null;
      this.filtro.status = filtros.status;
      this.filtro.tipoLinhaOrcamento = filtros.tipoLinhaOrcamento;
      this.filtro.marca = filtros.marca || '';
      this.filtro.linhaProduto = filtros.linhaProduto || '';
      this.filtro.familia = filtros.familia || '';
      this.filtro.produto = filtros.produto || '';
      this.filtro.cliente = filtros.cliente || '';
      this.filtro.meuPassoPendente = filtros.meuPassoPendente;
      this.filtro.meuPassoAprovado = filtros.meuPassoAprovado;

      this.filtro.idCliente = filtros.idCliente;
      this.filtro.idMarca = filtros.idMarca;
      this.filtro.idLinhaProduto = filtros.idLinhaProduto;
      this.filtro.idFamilia = filtros.idFamilia;
      this.filtro.idProduto = filtros.idProduto;
      this.filtro.idTipoLinhaOrcamento = filtros.idTipoLinhaOrcamento;

      this.statusBloqueado = this.filtro.meuPassoPendente || this.filtro.meuPassoAprovado;
    },
  },
  mounted() {
    this.filtroCopy = this.filtro;
    this.carregarWorkspace(this.entidade, this.preencherFiltros)
      .then(() => this.filtrarModal());
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/AcordoTabelaDash.vue?vue&type=script&lang=js&